import HeroBannerCard from '../components/common/hero-banner-card'
import Container from '../components/ui/container'
import { Page } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'

export type BlockProps = Extract<Page['hero'][0], { blockType: 'telesoft-hero-map' }>

function TelesoftHeroMap(block: BlockProps): ReactElement {
  const { slides } = block
  return (
    <>
      <div id="telesoft-city" className="min-h-screen bg-black w-full overflow-hidden relative">
        <div className="absolute inset-0 overflow-hidden">
          <Container className="h-screen flex justify-center items-center">
            <HeroBannerCard idx={0} terminal={true} slide={slides[0]} href={`${slides[0].slug}`} />
          </Container>
        </div>
      </div>
    </>
  )
}

export default TelesoftHeroMap
